/** Route of the Discover Workspaces page (avatar menu > Discover Workspaces, Figma 10216:3878). */
export const DISCOVER_WORKSPACES_PATH = '/discover-workspaces';
